interface CopyTooltipProps {
  show: boolean;
}

export default function CopyTooltip({ show }: CopyTooltipProps) {
  if (!show) return null;
  return (
    <div className="flex items-center gap-2 text-emerald-600 text-sm bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2">
      <div className="w-4 h-4 flex items-center justify-center">
        <i className="ri-check-line"></i>
      </div>
      商品文案已複製到剪貼簿！
    </div>
  );
}